// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeSandboxSquareFilledSvg from "@fishx/icons-svg/es/asn/CodeSandboxSquareFilled";
import FishxIcon from '../components/FishxIcon';

var CodeSandboxSquareFilled = function CodeSandboxSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxSquareFilledSvg
  }));
};

CodeSandboxSquareFilled.displayName = 'CodeSandboxSquareFilled';
export default React.forwardRef(CodeSandboxSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodeSandboxSquareFilled.js
// module id = 2276
// module chunks = 0